import type { CSSProperties, ReactNode } from 'react'

import css from './index.module.css'

interface Props {
    children?: ReactNode
    /**
     * @deprecated use style instead
     */
    gap?: string
    /**
     * @deprecated use children instead
     */
    items?: ReactNode[]
    style?: CSSProperties
}

// @todo: projít jde se všude používá a zkontrolovat, jestli někde není ten gap použitý
export const InputGroup = ({ children, items, style }: Props) => {
    return (
        <div className={css.inputGroup} role="group" style={{ ...style }}>
            {items?.map((item, index) => (
                <div key={index}>{item}</div>
            ))}
            {children}
        </div>
    )
}
